export class AlterarValorParcelaDTO {
    contratoId: number;
    parcelaId: number;
    novoValor: number;
    usuario: string;
}